import angular from 'angular'

import {
  has, some, keys, flatten,
  constant, uniqueId, difference,
  isPlainObject, camelCase, upperFirst
} from 'lodash-es'

const debugName = (name) => '_' + (/^[A-Z]/.test(name) ? upperFirst(camelCase(name)) : camelCase(name))

import deline from './deline'
import envRaw from './env-raw'
import deleteGlobal from './delete-global'
import genExposeName from './gen-expose-name'

angular
  .module('ggs.utils')
  .factory('debugObj', debugObjProvider)

function debugObjProvider($log, env) {
  const camelKey = camelCase(env.props.galleryKey)
  const exposeName = genExposeName(`ggsDebugObj_${camelKey}_:count:`)

  const addPair = (name, val) => {
    const keyName = debugName(name)
    if (has(debugObj, keyName)) {
      const newName = uniqueId(`${keyName}_`)
      $log.warn(deline(`
        debugObj:
          already has [name=${name}]
          as [keyName=${keyName}].
          Will use [newName=${newName}] instead!`))
      debugObj[newName] = val
    } else {
      debugObj[keyName] = val
    }
    return val
  }

  const addObject = (object) =>
    keys(object).forEach((name) => addPair(name, object[name]))

  const debugObj = (name, val) => isPlainObject(name)
    ? addObject(name)
    : addPair(name, val)

  debugObj.clear = () => {
    const allKeys = keys(debugObj)
    const userKeys = difference(allKeys, internalKeys)
    userKeys.forEach((key) => delete debugObj[key])
    return debugObj
  }

  debugObj.remove = (...rawValues) => {
    const values = flatten(rawValues)
    keys(debugObj)
      .filter((key) => some(values, (val) => val === debugObj[key]))
      .forEach((key) => delete debugObj[key])
    return debugObj
  }

  debugObj.disable = () => {
    deleteGlobal(exposeName)
    return debugObj
  }

  const internalKeys = keys(debugObj)

  if (envRaw.useDebugObj) {
    return window[exposeName] = debugObj
  } else {
    const mock = (_name, val) => val
    mock.clear = constant(mock)
    mock.remove = constant(mock)
    mock.disable = constant(mock)
    return mock
  }
}
